// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JOmzD","left":"styles_left__13xE5"};